// web/src/support-path.js
//
// Where Support's pages live (docs/superpowers/specs/2026-10-14-support-path-prefix-design.md).
// ops.adorapos.net is a platform of modules, each under its own prefix; the platform shell
// owns "/". Every Support page link, navigate() call and address comparison goes through
// this file, so moving Support again is a change to SUPPORT_BASE here and to the server's
// copy below, and nothing else.
//
// Page addresses only. Strings passed to api/client.js are API paths under /api and never
// come through here. The server's copy of the prefix (src/routes/support-redirects.js) is
// held equal to this one by test/routes/support-redirects.test.js.

export const SUPPORT_BASE = '/support';

/** A Support page's address: supportPath('/tickets/123?x=1') → '/support/tickets/123?x=1'. */
export function supportPath(path = '/') {
  if (typeof path !== 'string' || !path.startsWith('/')) {
    throw new Error(`supportPath needs a path starting with "/", got ${JSON.stringify(path)}`);
  }
  return path === '/' ? SUPPORT_BASE : `${SUPPORT_BASE}${path}`;
}

/**
 * The page path inside Support for an address, for comparisons against a Support page:
 * '/support/tickets' → '/tickets'. An address outside Support answers null, so a comparison
 * against it can never match by accident.
 */
export function stripSupportBase(pathname) {
  if (typeof pathname !== 'string') return null;
  if (pathname === SUPPORT_BASE || pathname === `${SUPPORT_BASE}/`) return '/';
  if (pathname.startsWith(`${SUPPORT_BASE}/`)) return pathname.slice(SUPPORT_BASE.length);
  return null;
}
